import React from 'react';
import { useLanguage } from '../context/LanguageContext';

/**
 * MedicalClinicSchema
 * Genererer usynligt Schema.org MedicalClinic JSON-LD script for Google Rich Results og søgemaskiner.
 * Benytter samme opbygning som FaqSchema.jsx på sitet (/autisme m.fl.).
 * Indeholder ét fælles datagrundlag hentet 1:1 fra sitets egne kontaktoplysninger.
 */

export const MEDICAL_CLINIC_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'MedicalClinic',
  'name': 'Nordisk Psykiatri',
  'url': 'https://www.nordiskpsykiatri.dk/',
  'logo': 'https://assets.auxodev.dk/assets/7d97f2cb-1a26-4176-9980-5fb38f404ca8/nordisk-psykiatri-kompaslogo.png',
  'image': 'https://assets.auxodev.dk/assets/7d97f2cb-1a26-4176-9980-5fb38f404ca8/inlineimage.png',
  'telephone': '+45 23 95 77 07',
  'email': 'kontakt@nordiskpsykiatri.dk',
  'address': {
    '@type': 'PostalAddress',
    'streetAddress': 'Vesterbrogade 37, 1. tv',
    'postalCode': '1620',
    'addressLocality': 'København V',
    'addressCountry': 'DK'
  },
  'medicalSpecialty': 'Psychiatric',
  'openingHoursSpecification': [
    {
      '@type': 'OpeningHoursSpecification',
      'dayOfWeek': [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday'
      ],
      'opens': '08:00',
      'closes': '16:00'
    },
    {
      '@type': 'OpeningHoursSpecification',
      'dayOfWeek': 'Sunday',
      'opens': '09:00',
      'closes': '16:00'
    }
  ]
};

export default function MedicalClinicSchema() {
  const { lang } = useLanguage();
  const schemaWithLang = {
    ...MEDICAL_CLINIC_SCHEMA,
    inLanguage: lang === 'en' ? 'en' : 'da',
    url: lang === 'en' ? 'https://www.nordiskpsykiatri.dk/en' : 'https://www.nordiskpsykiatri.dk/'
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaWithLang) }}
    />
  );
}
